// extracted by mini-css-extract-plugin
module.exports = {"page_section":"temp_page_section__1IcKP","text":"temp_text__1i3DU"};